<template>
    <div id="payment-page" class="payment-provider">

        <div class="payment-container">
            <div :ref="'card'" class="payment"></div>
        </div>
    </div>

</template>

<script>
import '@adyen/adyen-web/dist/adyen.css';
import Api from "@/api/Api";
import Locales from "@/utils/locales";
import {ShoppingCart} from "@/models/shopping";
import {CustomerMutations} from "@/store/customer/mutations";
import Uicookie from "@/utils/cookie";

let AdyenCheckout;
AdyenCheckout = require('@adyen/adyen-web');

export default {
    name: 'OrkAdyenPayment',
    components: {},
    props: {
        currentCart: {
            default: null
        },
    },
    data() {
        return {
            loadingCard: true,
        }
    },

    computed: {
        isUpdate: {
            get() {
                return this.$route.hash || false
            }
        },
        customer: {
            get() {
                return this.$store.getters.getProfile
            }
        },

    },
    async mounted() {
        this.initCheckout();
    },
    watch: {
        currentCart(newCart) {
            if (newCart) {
                this.initCheckout()
            }
        },
    },

    methods: {

        initCheckout() {
            this.loadingCard = true
            let amount;
            if (this.currentCart.specialPrice) {
                amount = this.currentCart.specialPrice.taxIncluded
            } else {
                amount = this.currentCart.totalPrice.taxIncluded
            }
            Api.payment.getPaymentMethods({amount: amount * 100}).then(async (data) => {

                const {
                    response, clientKey,
                    environment
                } = data;

                const configuration = {
                    paymentMethodsResponse: response,
                    clientKey,
                    locale: Locales.getLocaleCode(),
                    environment: environment,
                    showPayButton: false,
                    paymentMethodsConfiguration: {
                        card: {
                            //
                            // TODO: @cyril cf https://docs.adyen.com/payment-methods/cards/web-drop-in
                            //
                            //       * billingAddressRequired + billingAddressAllowedCountries
                            //         => idéalement il faudrait mettre l'adresse de billing pour réduire la fraude
                            //         => mais bon c'est pas très courant de redemander l'adresse de billing
                            //         => ça veut dire qu'il faudrait plus la demander dans le tunnel
                            //         => à oublier !
                            //
                            //       * styles: Set a style object to customize the card input fields. For a list of supported properties, refer to Styling card input fields.
                            //         => intéressant si tu veux styler un peu
                            //
                            //       * data: 	Object that contains placeholder information that you can use to prefill fields.
                            //                For example:
                            //                  - holderName: Placeholder for the card holder name field.
                            //                  - billingAddress: Object that contains placeholder information for the billing address such as street, postalCode, city, country, and stateOrProvince.
                            //         => peut-être marquer en français le placeholder holderName ? par défaut c'est J Smith ?
                            //         => "Nom du porteur de carte" ou un truc comme ça ? ou "Nom Prenom" ...
                            //
                            //       * events:
                            //           - onChange	      Called when the shopper enters data in the card input fields.
                            //           - onLoad	          Called once all the card input fields have been created but are not yet ready to use.
                            //           - onConfigSuccess  Called once the card input fields are ready to use.
                            //           - onFieldValid	  Called when a field becomes valid and also if a valid field changes and becomes invalid. For the card number field, it returns the last 4 digits of the card number.
                            //           - onBrand	      Called once we detect the card brand.
                            //           - onError       	  Called in case of an invalid card number, invalid expiry date, or incomplete field. Called again when errors are cleared.
                            //           - onFocus	      Called when a field gains or loses focus.
                            //           - onBinLookup	  Provides the type of the card, and the brands, supportedBrands, and detectedBrands arrays. Called as the user inputs the PAN.
                            //           - onBinValue	      Provides the BIN Number of the card (up to 6 digits), called as the user types in the PAN. Requires the client key for client-side authentication.
                            //
                            //         => à toi de voir ça peut servir onError par ex (ATTENTION card.onError, pas le onError global)
                            //            pour griser le bouton par ex ou quoi ... enfin ça dépend si tu veux customiser qqchose
                            //
                            hasHolderName: true,
                            holderNameRequired: true,
                            name: 'Credit or debit card',
                            amount: {
                                value: (this.currentCart.specialPrice.taxIncluded) ? this.currentCart.specialPrice.taxIncluded * 100 : this.currentCart.totalPrice.taxIncluded * 100,
                                currency: 'EUR'
                            }
                        }
                    },
                    onChange: (state, dropin) => {
                        // called when the shopper provides the required payment details
                        //
                        // TODO: @cyril tu as state.isValid, state.data, dropin de dispo si besoin de faire qqchose
                        this.$emit('paymentChange', {state, dropin});
                    },
                    onAdditionalDetails: (state, dropin) => {
                        // called when a payment method requires more details, for example for native 3D Secure 2,
                        // or native QR code payment methods

                        Api.payment.submitAdditionalDetails({
                            data: state.data,
                            user: this.customer,
                            cart: {
                                id: this.currentCart.id,
                                total: this.currentCart.totalPrice.taxIncluded * 100,
                                cartItems: this.currentCart.cartItems
                            }
                        })
                            .then((result) => {
                                if (result.action) {
                                    dropin.handleAction(result.action);
                                } else {
                                    this.$emit('handle-result', result);
                                }
                            })
                            .catch((error) => {
                                //   console.error('Call Server error: ', error)
                            }); // TODO: @cyril améliorer reporting d'erreur
                    },
                    onError: (error) => {
                        // TODO: @cyril pas sûr qu'il faille laisser ce genre de chose c'est plus pour débugger
                        //              peut-être qu'on peut afficher qqchose si le composant ne le fait pas ...
                        //              une simple "alert" ou un truc du genre ? Faut pas y passer 15j ...
                        // console.error(error);
                    }
                };
                const checkout = await AdyenCheckout(configuration);

                checkout.create('card').mount(this.$refs.card)


                //
                // TODO: @cyril tu peux faire .create('card', { showPayButton: false })
                //       et appeler integration.submit toi même si tu veux sortir le bouton plutôt que le skinner
                //       cf https://docs.adyen.com/online-payments/drop-in-web#step-2-add-drop-in
                //
                //       M'enfin je pense que c'est une perte de temps :)
                //
            }).catch((e) => {

            })
                .finally(() => {
                    this.loadingCard = false;
                })
        },
        submitPayment(paymentData, cart) {

            if (paymentData.state && paymentData.state.isValid) {
                Api.payment.initiatePayment({data: paymentData.state.data, user: this.customer, cart})
                    .then(result => {
                        const dropin = paymentData.dropin;

                        if (result.action) {
                            dropin.handleAction(result.action);
                        } else {
                            this.$emit('handleResult', result);
                        }
                    })
                    .catch((error) => {
                        // TODO: @cyril améliorer reporting d'erreur
                        // console.error('Call Server error: ', error);
                        console.log("error", error)
                        if (error.error.status === 400) {

                            this.$emit('handleResult', {resultCode: "updateCart"});

                            // location.reload();
                        } else {
                            this.$emit('handleResult', error);
                        }
                    })
            }
        }
    }
};

</script>

<style lang="scss" scoped>
.title {
  margin: var(--spacer-xl) 0 var(--spacer-base) 0;
}

.payment-provider {
  .sf-radio {
    &__label {
      display: flex;
      justify-content: space-between;
    }

    &__description {
      --radio-description-margin: 0;
      --radio-description-font-size: var(--font-xs);
    }
  }
}

.form {
  --button-width: 100%;
  @include for-desktop {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    --button-width: auto;
  }

  &__action {
    @include for-desktop {
      flex: 0 0 100%;
      display: flex;
    }
  }

  &__action-button {
    &--secondary {
      @include for-desktop {
        order: -1;
        text-align: left;
      }
    }

    &--add-address {
      width: 100%;
      margin: 0;
      @include for-desktop {
        margin: 0 0 var(--spacer-lg) 0;
        width: auto;
      }
    }
  }

  &__back-button {
    margin: var(--spacer-xl) 0 var(--spacer-sm);

    &:hover {
      color: var(--c-white);
    }

    @include for-desktop {
      margin: 0 var(--spacer-xl) 0 0;
    }
  }

  &__radio-group {
    flex: 0 0 100%;
    margin: 0 0 var(--spacer-xl) 0;
    @include for-desktop {
      margin: 0 0 var(--spacer-2xl) 0;
    }

  }
}
</style>
